// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__pfyZF","options":"AnswerScale_options__163GG","selected":"AnswerScale_selected__nEplK"};